type PastedData = Pick<DataTransfer, 'items' | 'getData'>

/**
 * Office apps put a picture of the copied text on the clipboard next to the
 * text itself, so a paste only counts as an image paste when it carries no text.
 */
export const pastedImageFiles = (data: PastedData | null): File[] => {
  if (!data?.items.length) return []
  if (data.getData('text/plain').trim()) return []

  return Array.from(data.items)
    .filter(item => item.kind === 'file' && item.type.startsWith('image/'))
    .map(item => item.getAsFile())
    .filter((file): file is File => !!file)
}
